export default __webpack_public_path__ + "static/media/waiting-room.7d515be2.svg";